import React from 'react';
import { Card } from './ui/card';
import { Quote } from 'lucide-react';

const Stories = () => {
  const stories = [
    {
      name: 'Martín Gómez',
      age: 19,
      sport: 'Fútbol',
      location: 'Santiago del Estero',
      story:
        'Gracias a la fundación, pasé de jugar en canchas de tierra en mi pueblo a firmar con un club de Primera División. El apoyo económico y los entrenadores profesionales cambiaron mi vida.',
      achievement: 'Contrato profesional con club de Primera',
      image: 'https://images.unsplash.com/photo-1622659097972-68f1d8c1829f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHx5b3VuZyUyMHNvY2NlciUyMHBsYXllcnMlMjB0cmFpbmluZ3xlbnwwfHx8fDE3ODI2ODIzNjl8MA&ixlib=rb-4.1.0&q=85',
    },
    {
      name: 'Lucía Fernández',
      age: 17,
      sport: 'Hockey',
      location: 'Salta',
      story:
        'En mi ciudad no había oportunidades para desarrollarme en hockey. La fundación me dio acceso a entrenamiento de elite y ahora formo parte de la selección juvenil provincial.',
      achievement: 'Selección juvenil provincial',
      image: 'https://images.unsplash.com/photo-1770669564911-bc1202acb626?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHx5b3V0aCUyMGF0aGxldGVzJTIwYWNoaWV2ZW1lbnR8ZW58MHx8fHwxNzgyNjgyNDA0fDA&ixlib=rb-4.1.0&q=85',
    },
    {
      name: 'Diego Rodríguez',
      age: 20,
      sport: 'Fútbol',
      location: 'Jujuy',
      story:
        'Sin recursos para viajar a Buenos Aires, mi sueño parecía imposible. La fundación no solo financió mi desarrollo, sino que me conectó con scouts profesionales. Hoy juego en Europa.',
      achievement: 'Contrato internacional en Europa',
      image: 'https://images.unsplash.com/photo-1609422644211-a85c36ee36a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHx5b3V0aCUyMHNwb3J0cyUyMHRyYWluaW5nfGVufDB8fHx8MTc4MjY4MjM3NHww&ixlib=rb-4.1.0&q=85',
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-sky-600 font-semibold text-sm uppercase tracking-wide mb-2 block">
            Historias Reales
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Sueños Hechos Realidad
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Conoce a algunos de los atletas cuyas vidas hemos transformado
          </p>
        </div>

        {/* Stories Grid */}
        <div className="grid lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {stories.map((story, index) => (
            <Card
              key={index}
              className="overflow-hidden border-2 border-gray-100 hover:border-sky-400 hover:shadow-2xl transition-all duration-300 group"
            >
              {/* Image */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={story.image}
                  alt={story.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-2xl font-bold text-white mb-1">{story.name}</h3>
                  <p className="text-sky-200 text-sm">
                    {story.age} años • {story.sport} • {story.location}
                  </p>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <Quote className="w-8 h-8 text-sky-400 mb-4" />
                <p className="text-gray-600 leading-relaxed mb-6">{story.story}</p>
                <div className="pt-6 border-t border-gray-100">
                  <div className="flex items-center space-x-2">
                    <div className="w-2 h-2 bg-sky-600 rounded-full"></div>
                    <span className="text-sm font-semibold text-sky-700">{story.achievement}</span>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Additional Image Section */}
        <div className="mt-20 max-w-5xl mx-auto">
          <div className="relative overflow-hidden rounded-2xl shadow-2xl">
            <img
              src="https://images.unsplash.com/flagged/photo-1568407371446-a239664fb4f4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxkaXZlcnNlJTIwc3BvcnRzJTIwdGVhbXxlbnwwfHx8fDE3ODI2ODI0MTB8MA&ixlib=rb-4.1.0&q=85"
              alt="Equipo diverso"
              className="w-full h-[400px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-sky-900/95 to-blue-900/80 flex items-center justify-center">
              <div className="text-center px-8">
                <h3 className="text-4xl sm:text-5xl font-bold text-white mb-4">
                  Tu Historia Puede Ser la Próxima
                </h3>
                <p className="text-xl text-sky-100 max-w-2xl mx-auto">
                  Cada colaboración empresarial crea más historias de éxito como estas
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stories;
